import { axiosInstance as axios } from './axiosManager';

const API_BASE = process.env.REACT_APP_HOST_API;

export const saveRrwebEvents = async (sessionId, userId, events) => {
  try {
    const response = await axios.post(`${API_BASE}/rrweb/events`, {
      sessionId,
      userId,
      events
    });
    return response.data;
  } catch (error) {
    console.error('Error saving rrweb events:', error);
    throw error;
  }
};

export const getRrwebEventsBySessionAndUser = async (sessionId, userId) => {
  try {
    const response = await axios.get(
      `${API_BASE}/rrweb/session/${sessionId}/user/${userId}`
    );
    return response.data.events;
  } catch (error) {
    console.error('Error fetching rrweb events:', error);
    throw error;
  }
};

export const getRrwebEventsBySession = async (sessionId) => {
  try {
    const response = await axios.get(`${API_BASE}/rrweb/session/${sessionId}`);
    return response.data.eventsByUser;
  } catch (error) {
    console.error('Error fetching rrweb events:', error);
    throw error;
  }
};